import { CZ, type FlagComponent, SK } from 'country-flag-icons/react/3x2'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

export interface LookupCountrySelectProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

/** Rejstřík, ve kterém se firma hledá (ARES pro Česko, RPO pro Slovensko). */
const countries: { code: string; name: string; Flag: FlagComponent }[] = [
  { code: 'CZ', name: 'Česko', Flag: CZ },
  { code: 'SK', name: 'Slovensko', Flag: SK },
]

// Obal drží poměr 3:2. Select dává ikonám v sobě size-4, proto má svg vlastní size-full.
const FlagMark = ({ Flag }: { Flag: FlagComponent }) => (
  <span aria-hidden className="inline-flex h-3.5 w-[21px] shrink-0 overflow-hidden rounded-[3px] shadow-[0_0_0_1px_rgb(0_0_0/0.08)]">
    <Flag className="block size-full" preserveAspectRatio="xMidYMid slice" />
  </span>
)

export const LookupCountrySelect = ({ value, onChange, className }: LookupCountrySelectProps) => {
  const current = countries.find((c) => c.code === value)

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={cn(className ?? 'border-0', 'gap-1.5')} aria-label={`Hledat v rejstříku: ${current?.name ?? 'vyberte zemi'}`}>
        <SelectValue placeholder="Země">{current && <FlagMark Flag={current.Flag} />}</SelectValue>
      </SelectTrigger>

      <SelectContent align="end">
        {countries.map(({ code, name, Flag }) => (
          <SelectItem value={code} key={code}>
            <span className="flex items-center gap-2.5">
              <FlagMark Flag={Flag} />
              {name}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

LookupCountrySelect.displayName = 'LookupCountrySelect'
